<template>
  <div class="flex">
    <div class="flex flex-row">
      <span class="font-bold">
        {{ addressDisplay }}
      </span>
      <span class="mx-2">
        {{ addressString }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    addressDisplay: String,
    address: Object,
  },
  computed: {
    addressString() {
      if (!this.address) {
        return ''
      }

      if (this.address.apartment) {
        return `${this.address.street}, ${this.address.apartment}, ${this.address.city} ${this.address.state}, ${this.address.zip_code}`
      }
      else {
        return `${this.address.street}, ${this.address.city} ${this.address.state}, ${this.address.zip_code}`
      }
    }
  }
}
</script>
